<style lang="scss" scoped>
.search-select {
  position: relative;
}
.search-select-input {
  appearance: none;
  text-align: left;
  cursor: pointer;
  user-select: none;
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  box-shadow: none;
  border-color: #d2d6de;
  white-space: nowrap;
  display: flex;
  align-items: center;

  &:focus {
    border-color: #3c8dbc;
  }
}
.search-select-placeholder,
.search-select-text {
  flex-grow: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.search-select__arrow {
  transition: all 200ms ease-in-out;

  &::before {
    display: block;
    color: #999;
    border-style: solid;
    border-width: 5px 5px 0;
    border-color: #999 transparent transparent;
    content: '';
  }

  &__open {
    transform: rotate(180deg);
  }
}
.search-select-dropdown {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  position: absolute;
  right: 0;
  left: 0;
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  z-index: 50;
  border: solid 1px #d2d6de;
  display: flex;
  flex-direction: column;
}
.search-select-search {
  display: block;
  padding: 0.5rem 0.75rem;
  background-color: #ededed;
  border: 1px solid #ccc;
  margin: 0.5rem;

  // &:focus {
  //   border-color: #3c8dbc;
  // }
}
.search-select-options {
  list-style: none;
  padding: 0;
  position: relative;
  overflow-y: auto;
  max-height: 206px;
  margin: 0;
}
.search-select-option {
  padding: 4px 6px;
  cursor: pointer;
  user-select: none;
  border-bottom: solid 1px #d2d6de;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #e9e9e9;
    color: rgb(94, 94, 94);
  }

  &.is-active {
    background-color: #269add;
    color: #fff;
  }
}
.search-select-empty {
  text-align: center;
  padding: 0.5rem;
}
.father-item,
.mother-item {
  display: flex;

  img {
    width: 35px;
    height: 45px;
    object-fit: cover;
    margin-right: 0.8rem;
    align-items: center;
    border-radius: 2px;
  }
  span {
    margin-top: 14px;
    margin-left: 12px;
  }
}
</style>

<template>
  <on-click-outside :do="close">
    <div class="search-select" :class="{ 'is-active': isOpen }">
      <ts-loading-banner :loading="fetching">
        <button
          ref="button"
          @click="open"
          type="button"
          class="search-select-input"
        >
          <span
            v-if="option !== null"
            class="search-select-text"
            :title="`${option.card_number} | ${option.full_name_en}`"
            >{{ option.card_number }} | {{ option.full_name_en }}</span
          >
          <span v-else class="search-select-placeholder">--Select--</span>
          <span
            class="search-select__arrow"
            :class="{ 'search-select__arrow__open': isOpen }"
          ></span>
        </button>
        <div
          ref="dropdown"
          v-show="isOpen"
          class="search-select-dropdown"
          @scroll="scrolled"
        >
          <input
            class="search-select-search"
            v-model="search"
            ref="search"
            @keydown.esc="close"
            @keydown.up="highlightPrev"
            @keydown.down="highlightNext"
            @keydown.enter.prevent="selectHighlighted"
            @input="searchText"
          />
          <ul
            ref="options"
            v-show="options.length > 0"
            class="search-select-options"
          >
            <li
              class="search-select-option"
              v-for="(option, i) in options"
              :key="option.parent_id"
              @click="toggleSelect(option)"
              :class="{ 'is-active': i === highlightedIndex }"
            >
              <table style="width: 100%">
                <tr>
                  <td class="with-img" width="10%">
                    <img
                      class="height-30 ts-rounded"
                      v-lazy="{
                        src: option.photo,
                        error: require('@/assets/user_default.png'),
                        loading: require('@/assets/Rolling-1s-200px_2.svg')
                      }"
                    />
                  </td>
                  <td class="ts-whitespace-no-wrap" width="20%">
                    {{ option.card_number }}
                  </td>
                  <td class="ts-whitespace-no-wrap" width="60%">
                    {{ option.full_name_en }}
                  </td>
                  <td class="ts-whitespace-no-wrap" width="10%">
                    {{ option.gender }}
                  </td>
                </tr>
              </table>
            </li>
          </ul>
          <div v-show="options.length === 0" class="search-select-empty">
            No parent found for
            <b>" {{ search }}"</b>
          </div>
          <div class="search-select-loading">
            <pt-waiting v-if="loading" v-show="loading"></pt-waiting>
          </div>
        </div>
      </ts-loading-banner>
    </div>
  </on-click-outside>
</template>

<script>
import Popper from 'popper.js'
import { isEqual, debounce } from 'lodash'
import OnClickOutside from '@/components/OnClickOutside.vue'

export default {
  name: 'TsSelectParent',
  components: {
    OnClickOutside
  },
  props: ['value', 'datescan'],
  data() {
    return {
      options: [],
      isOpen: false,
      highlightedIndex: null,
      option: null,
      loading: false,
      fetching: false,
      perPage: 100
    }
  },
  created() {
    this.fetchData()
  },
  beforeDestroy() {
    this.popper !== undefined && this.popper.destroy()
  },
  computed: {
    search: {
      get() {
        return this.$store.state.studentProfile.search
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_SEARCH', newValue)
        this.$store.commit('studentProfile/RESET_CURRENT_PAGE')
      }
    },
    page() {
      return Math.ceil(this.options.length / this.perPage + 1)
    }
  },
  methods: {
    async fetchData() {
      this.fetching = true
      await this.$store
        .dispatch('studentProfile/fetch', {
          page: -1,
          perPage: 50,
          paginate: true,
          fields: {
            setup_student_profiles:
              'student_id,card_number,gender,first_name_en,last_name_en,first_name_kh,last_name_kh,photo,ext_card_number'
          },
          // filter: {
          //   not_scan_campus_attendance: this.datescan
          // }
        })
        .then(response => {
          this.fetching = false
          this.options = response.data
          this.setDefaultOption()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetching = false
        })
    },
    open() {
      if (!this.isOpen) {
        this.isOpen = true
        this.$nextTick(() => {
          this.setupPopper()
          this.$refs.search.focus()
          this.scrollToHighlighted()
        })
      } else {
        this.isOpen = false
      }
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.button, this.$refs.dropdown, {
          placement: 'bottom',
          positionFixed: true,
          modifiers: {
            offset: {
              enabled: true,
              fn: data => {
                data.offsets.popper.left = data.offsets.reference.left
                data.offsets.popper.right = data.offsets.reference.right
                data.offsets.popper.width = data.styles.width = Math.round(
                  data.offsets.reference.width
                )
                return data
              },
              order: 840
            }
          }
        })
      } else {
        this.popper.scheduleUpdate()
      }
    },
    close() {
      if (!this.isOpen) {
        return
      }
      this.isOpen = false
      this.$refs.search.focus()
    },
    toggleSelect(option) {
      if (this.option === option) {
        this.option = null
        this.$emit('input', null)
        this.$emit('change', null)
        this.highlightedIndex = null
      } else {
        this.option = option
        this.$emit('input', option.student_id)
        this.$emit('change', option.student_id)
        this.highlightedIndex = this.options.indexOf(option)
      }

      // this.search = ''
      this.close()
    },
    selectHighlighted() {
      this.toggleSelect(this.options[this.highlightedIndex])
    },
    scrollToHighlighted() {
      let index = this.highlightedIndex === null ? 0 : this.highlightedIndex

      this.$refs.options.children.length > 0 &&
        this.$refs.options.children[index].scrollIntoView({
          block: 'nearest'
        })
    },
    highlight(index) {
      this.highlightedIndex = index

      if (this.highlightedIndex < 0) {
        this.highlightedIndex = this.options.length - 1
      }

      if (this.highlightedIndex > this.options.length - 1) {
        this.highlightedIndex = 0
      }

      this.scrollToHighlighted()
    },
    highlightPrev() {
      this.highlight(this.highlightedIndex - 1)
    },
    highlightNext() {
      this.highlight(this.highlightedIndex + 1)
    },
    searchText(event) {
      if (!this.isOpen) {
        this.open()

        this.$nextTick(() => {
          this.popper.scheduleUpdate()
        })
      }
    },
    async loadData() {
      let response = await axios.get('/resource/studentdatatable', {
        params: {
          search: this.search,
          order_by: 'first_name_en',
          per_page: this.perPage,
          page: this.page
        }
      })

      response.data.forEach(el => {
        let option = this.options.find(opt => opt.student_id == el.student_id)

        if (option !== undefined) return

        this.options.push(el)
      })
    },
    async scrolled(event) {
      let scrollObject = event.target

      //visible height + pixel scrolled = total height
      if (
        scrollObject.offsetHeight + scrollObject.scrollTop >=
        scrollObject.scrollHeight
      ) {
        this.loading = true
        await this.loadData()
        this.loading = false

        event.target.scrollTo(0, scrollObject.scrollTop - 20)
      }
    },
    setDefaultImage(event) {
      event.target.src = '/img/user_default.png'
    },
    setDefaultOption() {
      let option = this.options.find(opt => opt.student_id === this.value)

      if (option === undefined) {
        this.option = null
        return
      }

      this.option = option
      this.highlightedIndex = option.student_id
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    isOpen(isOpen) {
      if (!isOpen) {
        // this.search = ''
      }
    },
    value: {
      handler(val) {
        if (this.option === null || this.option === undefined) return
        if (isEqual(val, this.option.student_id)) return

        this.setDefaultOption()
      },
      immediate: true
    },
    datescan: function (val) {
      if (val) {
        this.fetchData()
      }
    }
  }
}
</script>
